import { TypeBuildingAction } from "../features/player-base/buildings/reducerBuildings";
import { selectActiveTutorialConfig } from "./selectTutorial";
export var selectIsHudVisible = function (state) {
    var tutorialConfig = selectActiveTutorialConfig(state);
    var showHudOnTutorial = tutorialConfig != undefined ? !tutorialConfig.hideHud : true;
    var isBuildingActionNone = state.playerBase.buildings.action === TypeBuildingAction.None;
    return showHudOnTutorial && isBuildingActionNone;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectIsHudVisible.ts
// module id = 585
// module chunks = 3